import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { useBasePath } from '@/lib/paths'
import { BusinessOfficers } from '@/types'
import { Mail, Users } from 'lucide-react'

type Props = {
  business: { id: string; name: string }
  officers: BusinessOfficers
}

function OfficerCard({ title, email }: { title: string; email: string | null }) {
  return (
    <div className="border rounded-lg px-4 py-4">
      <div className="flex items-center gap-2 mb-2">
        <Users className="w-4 h-4 text-muted-foreground" />
        <h3 className="text-sm font-medium text-foreground">{title}</h3>
      </div>
      {email ? (
        <a
          href={`mailto:${email}`}
          className="inline-flex items-center gap-1.5 text-sm text-blue-600 hover:underline"
        >
          <Mail className="w-3.5 h-3.5" />
          {email}
        </a>
      ) : (
        <p className="text-sm text-muted-foreground">Not yet assigned</p>
      )}
    </div>
  )
}

export default function BusinessOfficersShow({ business, officers }: Props) {
  const basePath = useBasePath()

  return (
    <DashboardLayout
      title="Officers"
      breadcrumbs={[
        { label: 'Businesses', href: 'businesses' },
        { label: business.name, href: `businesses/${business.id}` },
        { label: 'Officers' },
      ]}
    >
      <div>
        <h1 className="text-xl font-semibold tracking-tight mb-1">Officers</h1>
        <p className="text-sm text-muted-foreground mb-6">
          Your dedicated compliance and support officers.
        </p>

        <div className="space-y-3">
          <OfficerCard
            title="Compliance Officer"
            email={officers.compliance_officer?.email ?? null}
          />
          <OfficerCard
            title="Support Officer"
            email={officers.support_officer?.email ?? null}
          />
        </div>
      </div>
    </DashboardLayout>
  )
}
